import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { IGetLastLogTotem } from './types';

export const MUTATION_KEY_TOTEM_LOGS = 'TOTEM_LOGS';

interface useGetLogsParams {
    totemId: string | number | null | undefined;
    storeId: string | number | undefined;
}

export function useGetLogs(params: useGetLogsParams) {
    const queryFn = async () => {
        const { totemId, storeId } = params;

        try {
            const { data }: { data: IGetLastLogTotem } = await api.get(
                `/totem/logs/${storeId}/${totemId}/last`,
            );
            return data;
        } catch (error: any) {
            throw new Error(error);
        }
    };

    return useQuery({
        queryFn,
        queryKey: ['TOTEM_LOGS', params.totemId],
        enabled: !!params.storeId && !!params.totemId,
    });
}
